import { useSelector } from "react-redux";

import RelatedLinks from "../RelatedLinks/component";
import { MORE_FROM_THIS_EPISODE } from "../../constants";

const getRelatedEpisode = ({ type, episode }) => {
    if (type !== "segment") return [];

    if (episode) {
        const epCopy = Object.assign({}, episode);
        epCopy.title = "FULL EPISODE: " + epCopy.title;
        return [epCopy];
    }
};

const RelatedSegments = () => {
    const type = useSelector((state) => state.detail.content.type);
    const segments = useSelector((state) => state.detail.content.segments);
    const episode = useSelector((state) => state.detail.content?.episode);

    const contentId = useSelector((state) => state.app.contentId);

    const relatedEpisode = getRelatedEpisode({ type, episode });
    const newSegments = Array.isArray(segments)
        ? segments.filter((segment) => segment.sourceId !== contentId)
        : [];
    return (
        <RelatedLinks
            intlinks={newSegments}
            eplinks={relatedEpisode}
            heading={MORE_FROM_THIS_EPISODE}
        />
    );
};

export default RelatedSegments;
